<template>
  <div>
  </div>
</template>

<script>
'use strict';

// Imports.
import { mapState } from 'vuex';
import { useTask } from 'vue-concurrency';
import store from '/src/store';
import config from '/src/config'

// Set up the default component.
export default {
  props: {
    callback: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapState({
      ethereum: state => state.ethers,
    })
  },

  created() {
    let ethereumReference = this.ethereum;
    this.getLaunchpadItemsTask = useTask(function*(signal, callback) {
      this.config = config;
      if (!ethereumReference.provider) {
        yield store.dispatch('ethers/initialize', async () => {
          await callback();
        });
      } else {
        yield callback();
      }
    });
    this.getLaunchpadItemsTask.perform(this.callback);
  }
}
</script>
